import { useState, useEffect } from 'react'

export const useLoadingState = (initialLoading = true) => {
  const [isLoading, setIsLoading] = useState(initialLoading)

  useEffect(() => {
    // Simulate loading time
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 3000) // 3 seconds loading

    return () => clearTimeout(timer)
  }, [])

  const setLoading = (loading: boolean) => {
    setIsLoading(loading)
  }

  return { isLoading, setLoading }
}
